import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'

import AuthDataService from 'src/services/auth.service'
import { ISignInEmailVerificationDto } from 'src/types'

import { AppEvents } from 'src/constants'

const useSendNewEmailVerification = () => {
  const navigate = useNavigate()

  return useMutation(
    (dto: ISignInEmailVerificationDto) => AuthDataService.sendNewEmailVerifiaction(dto),
    {
      onSettled: (data) => {
        if (!data) return

        if (data.isEmailTaken) {
          const detail = { message: 'This email is already in use' }

          const event = new CustomEvent(AppEvents.HTTP_ERROR, { detail })
          document.dispatchEvent(event)
        }

        if (data.activation_token) {
          navigate(`/register/email/${data.activation_token}`)
        }
      },
    },
  )
}

export { useSendNewEmailVerification }
